import { defaultThemeColors } from '@/plugins/vuetify/themeColors'

// Only app-owned, statically imported SVG artwork should be passed to this helper.
export function themeSvgMarkup(markup, { tintUnknownFills = false } = {}) {
  return markup.replace(/\bfill="([^"]+)"/g, (attribute, fill) => {
    const color = fill.toLowerCase()
    if (color === defaultThemeColors.primary.toLowerCase()) {
      return 'fill="rgb(var(--v-theme-primary))"'
    }
    if (color === defaultThemeColors.secondary.toLowerCase()) {
      return 'fill="rgb(var(--v-theme-secondary))"'
    }
    if (tintUnknownFills && color === 'white') {
      return 'fill="rgb(var(--v-theme-surface))"'
    }
    if (tintUnknownFills && /^#[\da-f]{6}$/.test(color)) {
      return 'fill="rgba(var(--v-theme-primary), 0.12)"'
    }
    return attribute
  })
}
